import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ForgotPassword } from './action-types';
import { HttpMethods, resolveApiPath } from '@codametrix/ui-common';
import { ANALYTICS_ACTION_METADATA } from './action-constants';

const initializeForgotPassword = createAction<void>(ForgotPassword.INIT);

const reduxSavePasswordDto = createAction<CMxAPI.PasswordReset>(
  ForgotPassword.SAVE_PASSWORD_DTO
);

const _submitNewPassword = createAction(
  ForgotPassword._SUBMIT_NEW_PASSWORD,
  (value: CMxAPI.PasswordReset) => ({ payload: value, meta: ANALYTICS_ACTION_METADATA })
);

const submitForgotPassword = createAction(
  ForgotPassword.SUBMIT_FORGOT_PASSWORD,
  (value: string) => ({ payload: value, meta: ANALYTICS_ACTION_METADATA })
);

const handleForgotPassword = createAsyncThunk<void, string, { rejectValue: CMxCommonApp.SubmitError }>(
  ForgotPassword.FORGOT_PASSWORD,
  async (username, { dispatch }) => {
    dispatch(submitForgotPassword(username));
    const url = encodeURIComponent(username);
    await fetch(resolveApiPath(`/users/resetPassword/v1?username=${url}`), {
      method: HttpMethods.POST,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
);

const submitNewPassword = createAsyncThunk<
  CMxAPI.PasswordReset,
  CMxAPI.PasswordReset,
  { rejectValue: CMxCommonApp.FormErrors }
>(
  ForgotPassword.SUBMIT_NEW_PASSWORD,
  async (passwordReset, { dispatch, rejectWithValue }) => {
    dispatch(_submitNewPassword(passwordReset));
    const res = await fetch(resolveApiPath(`/users/savePassword/v1`), {
      method: HttpMethods.POST,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(passwordReset)
    });
    const { status } = res;
    if (status !== 200) {
      return rejectWithValue(await res.json());
    }
    return await res.json();
  }
);

export {
  handleForgotPassword,
  submitNewPassword,
  reduxSavePasswordDto,
  initializeForgotPassword
};
